import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {PageBody, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {Outlet} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const PatientsRoute = () => {
    const permissions = usePermissions()

    if (!permissions?.patients?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <PageContent>
                <Outlet />
            </PageContent>
        </PageBody>
    )
}
